// extracted by mini-css-extract-plugin
export default {"container":"PromoCode-module__container__nLlWX","effect":"PromoCode-module__effect__VQ0tw","button":"PromoCode-module__button__dLYBj"};